var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionWind({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 6.5a3.5 3.5 0 1 1 3.5 3.5H2V8h13.5A1.5 1.5 0 1 0 14 6.5h-2Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 14.5a3.5 3.5 0 1 0 3.5-3.5H2v2h16.5a1.5 1.5 0 1 1-1.5 1.5h-2Z",
    clipRule: "evenodd",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 17a3 3 0 1 0 3-3H2v2h10a1 1 0 1 1-1 1H9Z",
    clipRule: "evenodd",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionWind);
export default __webpack_public_path__ + "static/media/ic_action_wind.c4b1cbbcf903493f38de26cf43097969.svg";
export { ForwardRef as ReactComponent };